import React, { useEffect, useState } from "react";
import PageLoading from "../../helpers/PageLoading";
import { useHistory, useParams } from "react-router";
import { connect } from "react-redux";
import { DndProvider } from "react-dnd";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import {
  currencyValues,
  getDuration,
  getError,
} from "../../store/helpers/common_functions";
import moment from "moment";
import {
  Box,
  Button,
  Chip,
  LinearProgress,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import TabPanel from "../../helpers/TabPanel";
import ProjectDeliverable from "./ProjectActivities";
import ProjectAssignment from "../../components/Project/ProjectAssignment";
import ProjectAttachment from "../../components/Project/ProjectAttachment";
import { StyledTableRow } from "../../helpers/CustomMenu";
import DeleteDialog from "../../helpers/DeleteDialog";
import FormDialog from "../../helpers/FormDialog";
import HistoryComponent from "components/HistoryComponent";
import StatusLayout from "components/Status";
import { FaArrowLeft, FaBackspace, FaClock, FaMoneyBillWave, FaUserCog } from "react-icons/fa";
import WorklogManager from "views/admin/WorklogManager";

const MeetingAttended = ({ meetingList }) => {
  const history = useHistory();
  return (
    <TableContainer>
      <Table sx={{ minWidth: 700 }}>
        <TableHead>
          <TableCell>#</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Venue</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>End Date</TableCell>
          <TableCell>Status</TableCell>
        </TableHead>
        <TableBody>
          {meetingList?.length > 0 ? (
            meetingList?.map((row, i) => (
              <StyledTableRow
                onClick={() => history.push(`/admin/meeting/details/${row.id}`)}
                key={row.id}
                hover={true}
              >
                <TableCell>{i + 1}</TableCell>
                <TableCell>{row?.name}</TableCell>
                <TableCell>{row?.venue}</TableCell>
                <TableCell>
                  {moment(row?.startDate).format("YYYY-MM-DD")}
                </TableCell>
                <TableCell>
                  {moment(row?.endDate).format("YYYY-MM-DD")}
                </TableCell>
                <TableCell>
                  <Chip size={"small"} label={row?.status} />
                </TableCell>
              </StyledTableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6}>
                <div className={"text-center"}>{"No Meetings found"}</div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};


function PartnerProjectDetails({
  FetchDetails,
  PutAction,
  GetAllMeetingList,
  systemSettings,
  loggedUser,
}) {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState();
  const [tabValue, setTabValue] = React.useState(0);
  const [show, setShow] = React.useState(false);
  const [manualsDev, setManualsDev] = React.useState();
  const [manualsDevOps, setManualsDevOps] = React.useState();
  const [value, setValue] = useState({});
  const [deleteOpen, setDeleteOpen] = useState(0);
  const [status, setStatus] = useState();
  const [open, setOpen] = useState(0);
  const [openExtend, setOpenExtend] = useState(0);
  const [funders, setFunders] =   useState([]);
  const [partners, setPartners] = useState([]);
  const mainBackground = systemSettings?.mainBackground;


  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const hasDeliverable = info?.deliverables?.length > 0;
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const { id } = useParams();

  const loadData = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails(`/api/project/details/${id}`);
    const manualsDoc = await FetchDetails(`/api/home/documents`);
    setLoading(false);
    if (manualsDoc.status) {
      setManualsDev(
        manualsDoc.data?.filter((item) => item?.type === "developers")
      );
      setManualsDevOps(
        manualsDoc.data?.filter((item) => item?.type === "devops")
      );
    }
    if (resp.status) {
      // if (info) {
        // if (!hasDeliverable && resp.data.deliverables.length) {
        //   setTabValue((v) => v - 1);
        // } else if (hasDeliverable && !resp.data.deliverables.length) {
        //   setTabValue((v) => v + 1);
        // }
      // }
      setInfo(resp.data);
    } else {
      setError(getError(resp));
    }
    return resp;
  };

  useEffect(() => {
    loadData().then();
  }, [id]);
  

  useEffect(() => {
    const query = `projectId=${id}`;
    GetAllMeetingList(query);
  }, []);

      useEffect(async () => {
        const fetchFunders = await FetchDetails(`/api/funder/assigned?projectId=${id}`);
        const fetchPartners = await FetchDetails(`/api/partner/assigned?projectId=${id}`);
          if (fetchFunders.status) {
              setFunders(fetchFunders.data.data);
          }
          if (fetchPartners.status) {
            setPartners(fetchPartners.data.data);
        }
      }, [id]);

  const nIndex = hasDeliverable ? 0 : 1;

  const history = useHistory();

  const initiator = info?.project?.initiator === loggedUser?.Resource?.id;
  // const supervisor = info?.assignees.find((v) => v.role === "supervisor");
  // const isSupervisor = supervisor?.Resource?.id === loggedUser?.Resource?.id;
  // const canEdit = isSupervisor || initiator || loggedUser?.allowAllProject;
  const canEdit = loggedUser?.allowProject;

  return (loading && !info) || error || !info ? (
    <PageLoading error={loading ? null : error} onRefresh={loadData} />
  ) : (
    <div className={"flex flex-wrap"}>
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={loadData}
        setOpen={setOpen}
        url={`/api/project/update/${info.project.id}`}
        title={"Edit Project"}
        fields={[
          {
            name: "name",
            label: "Project name",
            value: value["name"],
            required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            value: value["startDate"],
            required: true,
            // hidden: info.project.status === 'overdue',
            setValue: (val) => setValue0("startDate", val),
          },
          {
            name: "endDate",
            label: "End Date",
            type: "date",
            value: value["endDate"],
            required: true,
            // hidden: !info.project.status === 'overdue',
            setValue: (val) => setValue0("endDate", val),
          },
          {
            name: "extendedFrom",
            label: "Extended From",
            type: "date",
            value: value["extendedFrom"],
            // required: true,
            hidden: !info.project?.extendedFrom,
            setValue: (val) => setValue0("extendedFrom", val),
          },
          {
            name: "extendedTo",
            label: "Extended To",
            type: "date",
            value: value["extendedTo"],
            // required: true,
            hidden: !info.project?.extendedFrom,
            setValue: (val) => setValue0("extendedTo", val),
          },
          {
            name: "supportStart",
            label: "Support Start From",
            type: "date",
            value: value["supportStart"],
            // required: true,
            hidden: !info.project?.supportStart,
            setValue: (val) => setValue0("supportStart", val),
          },
          {
            name: "supportTo",
            label: "Support Start To",
            type: "date",
            value: value["supportTo"],
            // required: true,
            hidden: !info.project?.supportStart,
            setValue: (val) => setValue0("supportTo", val),
          },
          {
            name: "client",
            label: "Client",
            value: value["client"],
            required: true,
            setValue: (val) => setValue0("client", val),
          },
          {
            name: "contractType",
            label: "Contract Type",
            type: "select",
            values: [
              { label: "Lumpsum", value: "lumpsum" },
              { label: "Framework", value: "framework" },
            ],
            value: value["contractType"],
            required: true,
            setValue: (val) => setValue0("contractType", val),
          },
          {
            name: "budgetAmount",
            label: "Budget",
            type: "number",
            value: value["budgetAmount"],
            required: true,
            setValue: (val) => setValue0("budgetAmount", val),
          },
          {
            name: "amountType",
            label: "Currency Type",
            type: "select",
            values: currencyValues,
            value: value["amountType"],
            required: true,
            setValue: (val) => setValue0("amountType", val),
          },
          {
            name: "paidAmount",
            label: "Pre Paid Amount",
            type: "number",
            value: value["paidAmount"],
            // required:true,
            setValue: (val) => setValue0("paidAmount", val),
          },
          {
            name: "termsOfReference",
            label: "Terms Of Reference",
            type: "file-drag",
            multiple: true,
            accept: ["PDF"],
            value: value["termsOfReference"],
            required: false,
            setValue: (val) => setValue0("termsOfReference", val),
          },
          {
            name: "description",
            label: "Project Description",
            value: value["description"],
            required: false,
            type: "editor",
            col: 12,
            setValue: (val) => setValue0("description", val),
          },
        ]}
      />
      {/* //extenation */}
      <FormDialog

        maxWidth={"md"}
        col={6}
        open={openExtend > 0}
        onSuccess={loadData}
        setOpen={setOpenExtend}
        url={`/api/project/update/${info.project.id}`}
        title={status === "in-support" ? "In Support" : "Extended Project"}
        fields={[
          {
            name: "name",
            label: "Project name",
            value: value["name"],
            // required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },

          {
            name: "extendedFrom",
            label: "Extended From",
            type: "date",
            value: value["extendedFrom"],
            // required: status !== 'in-support',
            setValue: (val) => setValue0("extendedFrom", val),
            hidden: status === "in-support",
          },
          {
            name: "extendedTo",
            label: "Extended To",
            type: "date",
            value: value["extendedTo"],
            // required: status !== 'in-support',
            setValue: (val) => setValue0("extendedTo", val),
            hidden: status === "in-support",
          },
          {
            name: "supportStart",
            label: "Support Start From",
            type: "date",
            value: value["supportStart"],
            // required: status === 'in-support',
            setValue: (val) => setValue0("supportStart", val),
            hidden: status !== "in-support",
          },
          {
            name: "supportTo",
            label: "Support Start To",
            type: "date",
            value: value["supportTo"],
            // required: status === 'in-support',
            setValue: (val) => setValue0("supportTo", val),
            hidden: status !== "in-support",
          },
          {
            name: "status",
            label: "Status",
            value: status === "in-support" ? "in-support" : "extended",
            hidden: true,
          },
          {
            name: "termsOfReference",
            label: "Terms Of Reference",
            type: "file-drag",
            multiple: true,
            accept: ["PDF"],
            value: value["termsOfReference"],
            hidden: true,
          },
        ]}
      />
      <DeleteDialog
        open={deleteOpen > 0}
        setOpen={() => {
          setDeleteOpen(0);
        }}
        onSuccess={deleteOpen === 2 ? loadData : history.goBack}
        body={{
          id: info.project.id,
          status,
        }}
        info={deleteOpen === 2}
        buttonTitle={deleteOpen === 2 ? status : "Delete"}
        title={deleteOpen === 2 ? `Add Project:${status}  !` : "Delete Project"}
        alertMessage={
          deleteOpen === 1
            ? "This project will be permanently deleted. Please ensure that you have informed all assignees."
            : null
        }
        url={
          deleteOpen === 1
            ? `/api/project/delete/${info.project.id}`
            : status !== "completed"
              ? `/api/project/hold/${id}`
              : `/api/project/complete/${id}`
        }
      />

      <div className="w-full xl:w-12/12 px-4">

        <div className="w-full">
          <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col gap-4">
            
            <div onClick={()=>history.goBack()} className="text-gray-500 flex items-center gap-2">
              <FaArrowLeft />
              <span className=" font-semibold ">{info?.project?.name}</span>
            </div>
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm  ">
              <div className="grid grid-cols-4 gap-4">
                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div className="">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaClock /> Project Start-End Date
                    </p>
                    <p className="font-semibold">
                      {moment(info?.project?.startDate).format("DD/MM/yyyy")} -{" "}
                      {moment(info?.project?.endDate).format("DD/MM/yyyy")}
                    </p>
                  </div>
                  {!loggedUser?.isPartner ? (
                    
                  <div className="flex items-center gap-2 ">
                    <div className="space-y-2">
                      <p className="text-gray-500 font-light flex items-center gap-2">
                        <FaMoneyBillWave /> Budget
                      </p>
                      <p className="font-semibold">
                        {info?.project?.budget ?? "N/A"}
                      </p>
                    </div>
                    <div className="space-y-2 font-light">
                      <p className="text-gray-500 flex items-center gap-2">
                        <FaMoneyBillWave /> Expenditure
                      </p>
                      <p className="font-semibold">
                        {info?.project?.expenses ?? "N/A"}
                      </p>
                    </div>
                  </div>
                  ): (
                    <div>
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaUserCog /> Assigned
                    </p>
                    <p className="font-semibold">{info?.project?.assignedTo ?? "N/A"}</p>
                  </div>
                  )}
                </div>
                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div>
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaClock /> Project Duration
                    </p>
                    <p className="font-semibold">
                      {
                        getDuration(
                          info.project?.endDate,
                          info.project?.startDate
                        )
                      }
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-light">Project Status</p>
                    <StatusLayout status={info?.project?.status} />

                  </div>
                </div>

                {!loggedUser?.isPartner && (        <div className="space-y-2 flex flex-col gap-6 justify-around">

                  <div>
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaUserCog /> Funder
                    </p>
                    <p className="font-semibold">
                      {info?.project?.fundedBy ?? "N/A"}
                    </p>
                  </div>

                  <div>
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaUserCog /> Assigned
                    </p>
                    <p className="font-semibold">{info?.project?.assignedTo ?? "N/A"}</p>
                  </div>
                </div>
              )}

                <div className="space-y-2">
                  <p className="text-gray-700 font-semibold">Description</p>
                  <p className="text-gray-600 font-normal text-sm">
                    {info?.project?.description}
                  </p>
                </div>


              </div>

            </div>
          </div>
        </div>

        <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example"
                               variant="scrollable"
                               scrollButtons
                               allowScrollButtonsMobile
                               sx={{
                                    "& button.Mui-selected": {
                                        color: mainBackground,
                                        borderBottom: `2px solid ${mainBackground}`,
                                    },
                                    " .MuiTabs-indicator": {
                                        backgroundColor: mainBackground,
                                    },

                               }}
                            >
                                <Tab label="Activities" {...a11yProps(nIndex + 0)} />
                                <Tab label="Project Documents" {...a11yProps(nIndex + 1)} />
                                <Tab label="Worklogs" {...a11yProps(nIndex + 2)} />
                            </Tabs>
                        </Box>

                        <TabPanel value={tabValue} index={0}>
                 
                 <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg border-0 mt-10">
                   <div className="rounded bg-white mb-0 px-0 py-0 overflow-hidden">
                     {loading ? <LinearProgress /> : null}
                     <Box sx={{ width: "100%" }}>
         
                       <ProjectDeliverable
                         info={info}
                         funders={funders}
                         partners={partners}
                         projectId={id}
                         onSuccess={loadData}
                         canEdit={canEdit}
                       />
         
         
                     </Box>
         
                   </div>
                 </div>
                            </TabPanel>
                  
                        <TabPanel value={tabValue} index={1}>
                            <ProjectAttachment info={info} onSuccess={loadData} canEdit={canEdit} />
                        </TabPanel>
                        <TabPanel value={tabValue} index={2}>
                            <WorklogManager inline={true} projectId={id} open={true} setOpen={() => false} canViewAll={canEdit} />
                        </TabPanel>
                    </Box>
      
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerProjectDetails);
